import { createSlice } from '@reduxjs/toolkit';

const initialState = { presaVisione: null, datiUtente: null };
const presaVisioneSlice = createSlice({
  name: 'presaVisione',
  initialState: initialState,
  reducers: {
    setData(state, action) {
      state.presaVisione = action.payload.presaVisione ?? null;
      state.datiUtente = action.payload.datiUtente ?? null;
    },
    setPresaVisione(state, action) {
      state.presaVisione = action.payload.presaVisione ?? null;
    },
    setDatiUtente(state, action) {
      state.datiUtente = action.payload.datiUtente ?? null;
    }
  }
});

export const presaVisioneActions = presaVisioneSlice.actions;
export default presaVisioneSlice.reducer;
